// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import { Turbo } from "@hotwired/turbo-rails"
import "./sentry"
import "./controllers"

// Indicateur circulaire Turbo (style mobile) : afficher / masquer
//
// Le voile n'apparaît qu'au-delà d'un seuil. Sans lui, la moindre navigation —
// y compris une visite servie depuis le cache Turbo en quelques dizaines de
// millisecondes — noircissait tout l'écran le temps d'un battement de cil :
// c'est ce clignotement qui trahit le site web plutôt que l'application.
// En dessous du seuil, l'utilisateur ne voit que l'écran suivant arriver.
const TURBO_PROGRESS_DELAY_MS = 300

let turboProgressTimer = null

function getTurboProgressOverlay() {
  return document.getElementById("turbo-progress-overlay")
}

function showTurboProgress() {
    // Un timer déjà armé signifie qu'une navigation est en cours : on le laisse courir
    // pour que le seuil se compte depuis la première, pas depuis la dernière.
    if (turboProgressTimer !== null) return

    turboProgressTimer = setTimeout(() => {
        turboProgressTimer = null
        const el = getTurboProgressOverlay()
        if (el) el.setAttribute("aria-hidden", "false")
    }, TURBO_PROGRESS_DELAY_MS)
}

function hideTurboProgress() {
    if (turboProgressTimer !== null) {
        clearTimeout(turboProgressTimer)
        turboProgressTimer = null
    }
  const el = getTurboProgressOverlay()
    if (el) el.setAttribute("aria-hidden", "true")
}

document.addEventListener("turbo:before-visit", showTurboProgress)
document.addEventListener("turbo:load", hideTurboProgress)
document.addEventListener("turbo:submit-end", hideTurboProgress)
document.addEventListener("turbo:request-failed", hideTurboProgress)
document.addEventListener("turbo:before-render", (e) => {
  if (e.detail.newBody) hideTurboProgress()
})
document.addEventListener("turbo:fetch-request-error", hideTurboProgress)

// Custom Turbo Stream action: open-global-drawer
// Usage: <%= turbo_stream_open_drawer(path) %> or <%= turbo_stream_open_drawer(path, height: "80vh") %>
Turbo.StreamActions.open_global_drawer = function() {
  const src = this.getAttribute("src")
  const height = this.getAttribute("height")
  
  document.dispatchEvent(new CustomEvent("global-drawer:open", {
    bubbles: true,
    detail: { src, height }
  }))
}

// Custom Turbo Stream action: close-global-drawer
Turbo.StreamActions.close_global_drawer = function() {
  document.dispatchEvent(new CustomEvent("global-drawer:close", {
    bubbles: true
  }))
}

// Custom Turbo Stream action: redirect (Turbo.visit) to avoid "Content missing" on 303
Turbo.StreamActions.redirect = function () {
    const url = this.getAttribute("url")
    if (url) Turbo.visit(url)
}

import "trix"
import "@rails/actiontext"

// Preline's resize handler reads window.$hsOverlayCollection.length before
// HSOverlay.init() has run, which crashes on slow devices (collection is undefined).
window.$hsOverlayCollection = window.$hsOverlayCollection || [];

import preline from "preline/dist/preline";

window.preline = preline;
import {HSOverlay} from "preline/dist/preline";

import HSRangeSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

window.noUiSlider = HSRangeSlider;

import UIService from "./ui-service";
import "./channels"

document.addEventListener("turbo:load", () => {
    // Reinitialize Preline components after each Turbo navigation
    InitPreline();
    UIService.init();
});

document.addEventListener("turbo:frame-load", (event) => {
    InitPreline();
});

// Reinitialize Preline components after turbo streams render
document.addEventListener("turbo:before-stream-render", (event) => {
    // Schedule reinitialization after the stream is applied
    setTimeout(() => {
        InitPreline();
    }, 50);
});

// Also listen for turbo:render to catch all rendering events
document.addEventListener("turbo:render", () => {
    InitPreline();
});

function InitPreline(event) {
    window.HSStaticMethods.autoInit();
}
